(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["index-simple-promobanner"] && !Shopify.designMode) return;
  try {
    
  /**
   * TDScheduledBanner - Web component for time-based banner visibility
   * Shows/hides the banner based on dateFrom and dateTo attributes
   */
  if (!customElements.get('td-scheduled-banner')) {
    class TDScheduledBanner extends HTMLElement {
      constructor() {
        super();
        this.dateFrom = null;
        this.dateTo = null;
        this.checkInterval = null;
      }

      connectedCallback() {
        this.initializeScheduling();
        this.setupVisibilityCheck();
      }

      disconnectedCallback() {
        this.clearInterval();
      }

      /**
       * Initializes the scheduling dates from data attributes
       */
      initializeScheduling() {
        const dateFromAttr = this.dataset.from;
        const dateToAttr = this.dataset.to;

        if (dateFromAttr) {
          this.dateFrom = this.parseDate(dateFromAttr);
        }

        if (dateToAttr) {
          this.dateTo = this.parseDate(dateToAttr);
        }
      }

      /**
       * Parses a date string in format "YYYY-MM-DD HH:MM:SS"
       * @param {string} dateString - The date string to parse
       * @returns {Date|null} - Parsed Date object or null if invalid
       */
      parseDate(dateString) {
        if (!dateString) return null;

        try {
          const date = new Date(dateString.replace(' ', 'T'));
          return isNaN(date.getTime()) ? null : date;
        } catch (e) {
          console.warn('TDScheduledBanner: Invalid date format', dateString);
          return null;
        }
      }

      /**
       * Sets up the visibility check interval
       */
      setupVisibilityCheck() {
        if (!this.dateFrom && !this.dateTo) {
          this.classList.add('td-simple-promo-banner--visible');
          return;
        }

        this.checkVisibility();
        this.checkInterval = setInterval(() => this.checkVisibility(), 60000);
      }

      /**
       * Checks if the banner should be visible based on current time
       */
      checkVisibility() {
        const now = new Date();
        let isVisible = true;

        if (this.dateFrom && now < this.dateFrom) {
          isVisible = false;
        }

        if (this.dateTo && now > this.dateTo) {
          isVisible = false;
        }

        this.updateVisibility(isVisible);
      }

      /**
       * Updates the visibility class on the element
       * @param {boolean} isVisible - Whether the banner should be visible
       */
      updateVisibility(isVisible) {
        if (isVisible) {
          this.classList.add('td-simple-promo-banner--visible');
        } else {
          this.classList.remove('td-simple-promo-banner--visible');
        }
      }

      /**
       * Clears the check interval
       */
      clearInterval() {
        if (this.checkInterval) {
          clearInterval(this.checkInterval);
          this.checkInterval = null;
        }
      }
    }

    customElements.define('td-scheduled-banner', TDScheduledBanner);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-search"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('td-search-controller')) {
    class TdSearchController extends HTMLElement {
      constructor() {
        super();
        this.searchFilterTypes = this.querySelectorAll('[data-search-filter-type]');
        this.searchResultTypes = this.querySelectorAll('[data-search-result-type]');
      }
      connectedCallback() {
        if (this.searchFilterTypes.length > 0 && this.searchResultTypes.length > 0) {
          this.searchFilterTypes.forEach(filterType => {
            filterType.addEventListener('click', this.handleClick.bind(this));
          });
        }
        if (this.dataset.paginatedTitle) {
          document.title = this.dataset.paginatedTitle;
        }
      }
      handleClick(event) {
        const target = event.target;
        if (target.disabled) {
          return;
        }
        const searchFilterType = target.dataset.searchFilterType || 'all';
        if (target.classList.contains('td-filter-type--is-active')) {
          return
        }
        this.searchFilterTypes.forEach(filterType => {
          filterType.classList.toggle('td-filter-type--is-active', filterType.dataset.searchFilterType === searchFilterType);
        });
        if (searchFilterType === 'all') {
          this.searchResultTypes.forEach(resultType => {
            resultType.classList.remove('td-result-type--is-hidden');
          });
        } else {
          this.searchResultTypes.forEach(resultType => {
            resultType.classList.toggle('td-result-type--is-hidden', searchFilterType !== resultType.dataset.searchResultType);
          });
        }
      }
    }
    customElements.define('td-search-controller', TdSearchController);
  }

  } catch(e) { console.error(e); }
})();
})();
